// extracted by mini-css-extract-plugin
module.exports = {"newPostsButton":"styles_newPostsButton__1s153","bullet":"styles_bullet__3HyNj","ampPillButton":"styles_ampPillButton__3RJ1I"};